<template>
  <Home />
</template>

<script>
import Home from "./components/Home.vue";
// import Form from "./components/Form.vue";

export default {
  name: "App",
  components: {
    Home,
  },
  data() {
    return {
      msg: "Hello World!",
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  background: rgba(194, 148, 148, 0.315) !important;
  /* background-image: url("..\assets\love.jpg"); */
}
</style>
